/*
 * © 2026 eggs unimedia GmbH
 * Coded with love 💛
 */

import React from 'react'
import { QRCodeSVG } from 'qrcode.react'

/**
 * QR-Code Design System Komponente.
 * Generisch wiederverwendbar — akzeptiert beliebigen String als value.
 * Wird in Epic 2 (Buchungscode), Epic 4 (QR-Claim UUID) und Epic 5 (Host QR) genutzt.
 *
 * @param {object} props
 * @param {string} props.value - Der zu encodierende Wert (Pflicht)
 * @param {number} [props.size=200] - Größe in Pixel
 * @param {string} [props.className] - Zusätzliche CSS-Klassen
 */
export default function QRCode({ value, size = 200, className = '' }) {
  if (!value) return null

  return (
    <div className={className}>
      <QRCodeSVG
        value={value}
        size={size}
        level="H"
        includeMargin
      />
    </div>
  )
}
